import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { RecaptchaData } from '@app/core/recaptcha/recaptcha-commons';
import { RecaptchaComponent } from '@app/core/recaptcha/components/recaptcha/recaptcha.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-password-resend-captcha',
  templateUrl: './password-resend-captcha.component.html',
  styleUrls: ['./password-resend-captcha.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RecaptchaComponent,
    TranslatePipe,
  ],
})
export class PasswordResendCaptchaComponent {
  @Output() public captchaFinished = new EventEmitter<RecaptchaData>();

  public finished(data: RecaptchaData): void {
    this.captchaFinished.emit(data);
  }
}
